import * as ActionTypes from '../../actionTypes/cabinListActionTypes';

const initialState = {
  initialized: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.INIT_FINISHED:
      return {
        ...state,
        initialized: true,
      }
    case ActionTypes.INIT_SUCCESS: {      
      return {
        ...state,
        ...action.cruise,
        totalDuration: action.totalDuration,
        priceDetails: action.priceDetails,
      }
    }
    case ActionTypes.SELECT_CABIN:
      return {
        ...state,
        selectedCabinKey: action.cabinKey,
      }
    default:
      return state;
  }
};
